import * as actions from './actions'
import {Map, fromJS} from 'immutable';

function reducer(
        state=Map({
            items: Map(),
            isFetching: false,
            isUploading: false,
        }),action) {

        switch (action.type) {
        // ========= REQUEST ===========
        case actions.EMPLOYEES_PUT:
            action.employees.forEach((employee) => {
                if(employee.id !== undefined && Object.getOwnPropertyNames(employee).length > 0){
                    state = state.setIn(["items", employee.id], fromJS(employee))
                }
            })
            return state;
        case actions.EMPLOYEES_PROFILE_IMG_SET:
        case actions.EMPLOYEES_PROFILE_IMG_DELETE:
            return state.setIn(['items', action.id, 'image_url'], action.imgUrl);

        case actions.EMPLOYEE_CREATE_REQUEST:
        case actions.EMPLOYEE_CREATE_FAILURE:
            return state.setIn('isFetching', action.isFetching);
        case actions.EMPLOYEE_CREATE_SUCCESS:
            return state
                .setIn('isFetching', action.isFetching)
                .setIn(['items', action.employee.id], fromJS(action.employee))

        case actions.EMPLOYEE_DELETE_REQUEST:
        case actions.EMPLOYEE_DELETE_FAILURE:
            return state.setIn('isFetching', action.isFetching);
        case actions.EMPLOYEE_DELETE_SUCCESS:
            return state.update('items', items => items.filter(item => {
            return item.get('id') !== action.id;
        }));

        case actions.EMPLOYEES_PROFILE_IMG_SET_UPLOAD:
        case actions.EMPLOYEES_PROFILE_IMG_SET_SUCCESS:
        case actions.EMPLOYEES_PROFILE_IMG_SET_FAILURE:
            return state
                    .set('isUploading', action.isUploading)

        case actions.EMPLOYEE_IS_ONLINE:
        case actions.EMPLOYEE_IS_OFFLINE:
            return state.setIn(['items', action.id, 'is_online'], action.online)

        case actions.EMPLOYEE_SET_NAME:
        return state.setIn(['items', action.id, 'name'], action.name)

        case actions.EMPLOYEE_SET_DISPLAY_NAME:
        return state.setIn(['items', action.id, 'display_name'], action.displayName)

        case actions.EMPLOYEE_SET_LOADING:
            return state.set('isUploading', action.isUploading);
        case actions.EMPLOYEE_SET_DONE:
            return state.set('isUploading', action.isUploading);
        default:
            return state;
      }
}


export default reducer;



// WEBPACK FOOTER //
// ./src/model/Employee/reducer.js